const countReviews = () => {
    const reviewsTab = document.querySelector('.tab.reviews-tab span');
    if(reviewsTab) {
        const reviews = document.querySelectorAll('.reviews-tab-review');
        let i = 0;
        reviews.forEach(item => {
            return i++
        })
        reviewsTab.innerHTML = i;
    }
}

export default countReviews;